import { useHistory, useParams } from "react-router-dom";
import { Card, ImagePicker, WhiteSpace, WingBlank } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { BaseURL } from "../../../../constant";

export default function ImageDetail() {
  const [fileList, setFileList] = useState<any[]>([]);
  const params = useParams<{
    uuid: string;
    name: string;
  }>();
  const history = useHistory();

  useEffect(() => {
    const files = [
      {
        url: `${BaseURL}/oa/common/attachment/showImage?id=${params.uuid}`,
      },
    ];
    setFileList(files);
  }, [fileList]);
  return (
    <>
      <WingBlank style={{ marginTop: 10, marginBottom: 5 }}>
        <span
          style={{
            marginTop: "5px",
            marginRight: "40px",
            fontSize: "inherit",
            color: "#1890ff",
          }}
          onClick={() => history.go(-1)}
        >
          返回
        </span>
        <span
          style={{
            marginTop: "5px",
            fontSize: "inherit",
            fontWeight: "bold",
            color: "#1890ff",
          }}
          onClick={() => history.go(-1)}
        >
          {params.name}
        </span>
      </WingBlank>
      <div>
        <div style={{ display: fileList.length == 0 ? "none" : "" }}>
          <WhiteSpace size="lg" />
          <ImagePicker
            files={fileList}
            onImageClick={(index, fs) => console.log(index, fs)}
            selectable={false}
            multiple={false}
            style={{ width: "90%", height: "90%" }}
          />
        </div>
      </div>
    </>
  );
}
